import React from "react";

export default function PageAccessRestricted({pageName="Predictors"}) {
  return (
    <div className="relative min-h-[610px] bg-gradient-to-br from-teal-50 via-cyan-50 to-emerald-50 flex items-center justify-center overflow-hidden rounded-lg">
      {/* Animated Background Bubbles */}
      <div className="absolute inset-0 overflow-hidden">
        {/* Large floating bubbles */}
        <div
          className="absolute top-20 left-10 w-32 h-32 bg-gradient-to-r from-blue-300 to-cyan-300 rounded-full opacity-20 animate-bounce"
          style={{ animationDuration: "6s", animationDelay: "0s" }}
        />
        <div
          className="absolute top-40 right-20 w-24 h-24 bg-gradient-to-r from-purple-300 to-pink-300 rounded-full opacity-20 animate-bounce"
          style={{ animationDuration: "8s", animationDelay: "2s" }}
        />
        <div
          className="absolute bottom-40 left-20 w-20 h-20 bg-gradient-to-r from-green-300 to-emerald-300 rounded-full opacity-20 animate-bounce"
          style={{ animationDuration: "7s", animationDelay: "1s" }}
        />
        <div
          className="absolute bottom-20 right-40 w-28 h-28 bg-gradient-to-r from-yellow-300 to-orange-300 rounded-full opacity-20 animate-bounce"
          style={{ animationDuration: "9s", animationDelay: "3s" }}
        />

        {/* Small pinging dots */}
        <div
          className="absolute top-32 left-1/4 w-3 h-3 bg-blue-400 rounded-full opacity-60 animate-ping"
          style={{ animationDuration: "3s", animationDelay: "0s" }}
        />
        <div
          className="absolute top-60 right-1/3 w-2 h-2 bg-pink-400 rounded-full opacity-60 animate-ping"
          style={{ animationDuration: "4s", animationDelay: "1s" }}
        />
        <div
          className="absolute bottom-60 left-1/3 w-4 h-4 bg-green-400 rounded-full opacity-60 animate-ping"
          style={{ animationDuration: "5s", animationDelay: "2s" }}
        />
        <div
          className="absolute bottom-32 right-1/4 w-3 h-3 bg-yellow-400 rounded-full opacity-60 animate-ping"
          style={{ animationDuration: "3.5s", animationDelay: "1.5s" }}
        />
      </div>

      {/* Main Content Card */}
      <div className="relative z-10 max-w-2xl w-full mx-4">
        <div className="bg-white backdrop-filter backdrop-blur-lg rounded-3xl shadow-2xl p-8 md:p-12 border border-teal-200">
          {/* Lock Icon Container */}
          <div className="flex justify-center mb-8">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-r from-teal-400 to-cyan-400 rounded-full blur-xl opacity-40 animate-pulse"></div>
              <div className="relative bg-gradient-to-br from-teal-100 to-cyan-100 backdrop-filter backdrop-blur-sm rounded-full p-6 border border-teal-300">
                <i className="fa-solid fa-lock text-6xl text-teal-700"></i>
              </div>
            </div>
          </div>

          {/* Title */}
          <h1 className="text-4xl md:text-5xl font-bold text-teal-900 text-center mb-4">
            Access Restricted
          </h1>

          {/* Subtitle */}
          <p className="text-xl text-teal-700 text-center mb-8">
            {pageName} Page
          </p>

          {/* Description */}
          <div className="bg-teal-50 rounded-2xl p-6 mb-8 border border-teal-200">
            <p className="text-gray-700 text-center leading-relaxed text-lg">
              Access to the{" "}
              <span className="font-semibold text-teal-900">"{pageName}"</span>{" "}
              page is restricted until all required steps in the previous
              sections are completed. Once those steps are successfully
              finished, this page will become available for use.
            </p>
          </div>

          {/* Footer Note */}
          <p className="text-teal-600 text-sm text-center mt-6 opacity-80">
            Complete all prerequisite steps to unlock this feature
          </p>
        </div>

        {/* Floating Elements */}
        <div className="absolute -top-10 -right-10 w-20 h-20 bg-cyan-300 rounded-full mix-blend-multiply filter blur-2xl opacity-40 animate-bounce"></div>
        <div className="absolute -bottom-10 -left-10 w-24 h-24 bg-teal-300 rounded-full mix-blend-multiply filter blur-2xl opacity-40 animate-bounce animation-delay-1000"></div>
      </div>

      <style jsx>{`
        .animation-delay-1000 {
          animation-delay: 1s;
        }
      `}</style>
    </div>
  );
}
